import React from 'react';
import Navbar from './Navbar';
import { useTranslation } from 'react-i18next';
import Footer from './Footer';

const Layout = ({ children, title, showAuthLinks = true }) => {
    const { t } = useTranslation();
    return (
        <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 flex flex-col">
            <Navbar showAuthLinks={showAuthLinks} />

            {/* Main Content */}
            <main className="flex-1 max-w-7xl mx-auto px-3 sm:px-6 lg:px-8 py-8 w-full min-h-[80vh]">
                {title && (
                    <div className="text-center mb-8">
                        <h1 className="text-4xl font-bold text-gray-900 mb-2">{title}</h1>
                        <p className="text-lg text-gray-600">{t('common.tagline')}</p>
                    </div>
                )}

                <div className="space-y-8">
                    {children}
                </div>
            </main>

            {/* Footer */}
            <div className="mt-auto">
                <Footer />
            </div>
        </div>
    );
};

export default Layout;
